module.exports = __webpack_public_path__ + "static/img/icon5-11.e3ab787f.png";